import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope, FaHeart } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <span className="footer__logo">
            <span className="footer__bracket">&lt;</span>SM<span className="footer__bracket"> /&gt;</span>
          </span>
          <p className="footer__tagline">AI Engineer | Building Intelligent Systems</p>
        </div>

        <div className="footer__socials">
          <a href="https://github.com/sudipmajkoti07" target="_blank" rel="noreferrer" aria-label="GitHub">
            <FaGithub />
          </a>
          <a href="https://linkedin.com/in/sudipmajkoti" target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <FaLinkedin />
          </a>
          <a href="mailto:sudipmazkoti@gmail.com" aria-label="Email">
            <FaEnvelope />
          </a>
        </div>

        <div className="footer__copy">
          <p>
            &copy; {new Date().getFullYear()} Sudip Majkoti. Built with <FaHeart className="footer__heart" /> and React.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
